import { sizedImageUrl } from '@alternativamais/chat-core';

/**
 * A imagem do chat no tamanho em que aparece (`pixelsCss` = maior lado, vezes
 * a densidade da tela): a API manda a miniatura em WebP, como o proxy de mídia
 * do Discord. Endereço de fora do chat não muda; o visualizador usa o original.
 */
export function noTamanho(url: string, pixelsCss: number): string {
  const densidade =
    typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1;
  return sizedImageUrl(url, Math.ceil(pixelsCss * densidade));
}
